import type { Address } from '@/domain/addresses';

export const getAddressDescription = (address?: Address, lot?: string) => {
  if (!address || !address.addr1) {
    return '';
  }

  const { addr1, addr2, city, state, postalCode } = address;
  const addr2Text = addr2 ? ` ${addr2}` : '';
  const lotText = lot ? `Lot ${lot} - ` : '';

  return `${lotText}${addr1}${addr2Text}, ${city}, ${state} ${postalCode}`;
};
